var path = 'js/views/start-view/start-view.template.html';
var html = "<div class=start-view> <div class=start-view__intro> <h1>Designing Your Own Garage Door Has Never Been Easier</h1> <p class=lead>Find the style that’s right for you and get a quote with our interactive tool</p> <div class=start-view__buttons> <button type=button class=\"btn btn-primary btn-lg\" ng-click=$ctrl.uploadPhoto();><i class=\"glyphicon glyphicon-camera\"></i> Use my own photo</button> <button type=button class=\"btn btn-primary btn-lg\" ng-click=$ctrl.browseProjects();><i class=\"glyphicon glyphicon-picture\"></i> Use a sample project </button> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/js/views/start-view/start-view.template.html
// module id = 182
// module chunks = 0